// extracted by mini-css-extract-plugin
module.exports = {"min":"SliderIndicatorsContainer_min__iVehN","max":"SliderIndicatorsContainer_max__16L82"};